import React, { useRef } from "react";
import { Box, Card } from "@curves/ui-base";
import useEChart from "@util/hook/useEChart";
import ChartSkeletonLoading from "@icoach/dashboard/ChartSkeletonLoading";
import { tooltipFormatter } from "@icoach/dashboard/dashboard.util";
import { formatCurrencyFn } from "@util/utils";

/********* 年度平均客單價 *********/
const YearlyAverageSpend = React.forwardRef((props, ref) => {
	const chartDomRef = useRef(null);
	const {
		sourceData = {
			series: {
				data: [
					{ meta: { key: "A (5K~8K)" }, value: 82, name: "A (5K~8K)", itemStyle: { color: "#7E2E9C" } },
					{ meta: { key: "B (3K~5K)" }, value: 45, name: "B (3K~5K)", itemStyle: { color: "#94A3B8" } },
					{ meta: { key: "C (1K~3K)" }, value: 35, name: "C (1K~3K)", itemStyle: { color: "#CBD5E1" } },
					{ meta: { key: "D (<1K)" }, value: 78, name: "D (<1K)", itemStyle: { color: "#E2E8F0" } },
					{ meta: { key: "S (8K+)" }, value: 125, name: "S (8K+)", itemStyle: { color: "#4C0073" } },
				],
				centerValueText: 4250,
			},
		},
	} = props;

	const { series = {} } = sourceData;
	const seriesData = series?.data ?? [];
	const centerValueText = formatCurrencyFn(series?.centerValueText ?? 0);
	const isLoading = seriesData.length === 0;
	const title = "年度平均客單價";

	const option = {
		title: {
			text: title,
			left: 24,
			top: 20,
			textStyle: {
				fontSize: 20,
				fontWeight: 600,
				color: "#1F2937",
			},
		},

		tooltip: {
			trigger: "item",
			formatter: tooltipFormatter,
		},

		legend: {
			bottom: 10,
			left: "center",
			textStyle: {
				fontSize: 14,
				fontWeight: 600,
				color: "#111827",
			},
		},

		graphic: [
			{
				type: "text",
				left: "center",
				top: "43%",
				style: {
					text: "平均客單",
					fill: "#94A3B8",
					fontSize: 12,
					textAlign: "center",
				},
			},
			{
				type: "text",
				left: "center",
				top: "50%",
				style: {
					text: `{value|${centerValueText}}{unit| 元}`,
					textAlign: "center",
					rich: {
						value: {
							fill: "#4C0073",
							fontSize: 20,
							fontWeight: 700,
						},
						unit: {
							fill: "#4C0073",
							fontSize: 10,
							fontWeight: 600,
						},
					},
				},
			},
		],

		series: [
			{
				type: "pie",
				radius: ["40%", "55%"],
				center: ["50%", "50%"],
				padAngle: 3,
				avoidLabelOverlap: false,
				label: { show: false },
				labelLine: { show: false },
				itemStyle: {
					borderRadius: 8,
				},
				data: seriesData,
			},
		],
	};

	useEChart(chartDomRef, option);

	return (
		<Card style={{ width: "100%", height: "100%" }}>
			<Card.CardContent style={{ width: "100%", height: "100%" }}>
				{isLoading ? <ChartSkeletonLoading /> : <Box ref={chartDomRef} style={{ width: "100%", height: "100%" }}></Box>}
			</Card.CardContent>
		</Card>
	);
});

export default YearlyAverageSpend;
